import { serialize } from 'utilities/data';
import { BREAKPOINTS } from 'constants';

export const computeNormalizedRects = (container, selectors) => {
    const containerRect = container.getBoundingClientRect(),
        childRects = Array.from(container.querySelectorAll(selectors)).map(child => {
            const id = isNaN(child.dataset.hyLegacyId) ? child.dataset.hyLegacyId : Number(child.dataset.hyLegacyId);

            return {
                id,
                classList: serialize(child.classList),
                dataset: serialize(child.dataset),
                ...serialize(child.getBoundingClientRect())
            }
        });

    const computed =
        childRects
            .filter(r => r.width > 0 && r.height > 0)
            .map(r => ({
                ...r,
                left: r.left - containerRect.left,
                right: containerRect.right - r.right,
                top: r.top - containerRect.top,
                bottom: containerRect.bottom - r.bottom
            }))
            .sort((a,b) => b.width - a.width); // sort from smallest to largest to prevent blocking

    return computed;
};

export const scaleToFit = (containerWidth, containerHeight, aspectRatioPercent) => {
    const physicalHeight = containerWidth * (aspectRatioPercent / 100),
        scaledWidthPercent = 1 / (physicalHeight / containerHeight) * 100,
        scaleInfo = {
            fitDirection: 'wide',
            verticalDifference: containerHeight - physicalHeight
        };

    if (physicalHeight > containerHeight) {
        scaleInfo.fitDirection = 'tall';
        scaleInfo.widthPercent = scaledWidthPercent;
    }

    return scaleInfo;
};

export const getScaleToFitStyles = (containerWidth, containerHeight, aspectRatioPercent) => {
    const scaleInfo = scaleToFit(containerWidth, containerHeight, aspectRatioPercent),
        styles = {
            margin: `${scaleInfo.verticalDifference / 2}px 0`
        };

    if (scaleInfo.fitDirection === 'tall') {
        styles.width = `${scaleInfo.widthPercent}%`;
        styles.left = 0;
        styles.right = 0;
        styles.margin = 'auto';
    }

    return styles;
};

export const computeVideoBreakpoint = (dimensions = {}) => {
    if (dimensions.width <= BREAKPOINTS.SMALL_PLAYER_WIDTH) {
        return 'small';
    }

    return 'regular';
}